// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Header-module--navLink--1wteX","navLinkSelected":"Header-module--navLinkSelected--nnJNy"};